import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from './configuration.service';
import { savePracticeSessionResponse } from '../models/savePracticeSessionResponse';
import { firstValueFrom } from 'rxjs';
import { savePracticeSessionRequest } from '../models/savePracticeSessionRequest';
import { savePracticeTemplateDrillRequest } from '../models/savePracticeTemplateDrillRequest';
import { savePracticeSessionDrillResultsRequest } from '../models/savePracticeSessionDrillResultsRequest';
import { searchPracticeSessionsRequest } from '../models/searchPracticeSessionsRequest';
import { practiceSessionSearchResponse } from '../models/practiceSessionSearchResponse';
import { searchPracticeSessionDrillResultsRequest } from '../models/searchPracticeSessionDrillResultsRequest';
import { practiceSessionDrillResultSearchResponse } from '../models/practiceSessionDrillResultSearchResponse';

@Injectable({
  providedIn: 'root'
})
export class PracticeService {

  constructor(private http:HttpClient, private configService:ConfigurationService) {
      this.baseUrl = this.configService.getApiEndpoint();
    }
    
    baseUrl:string;

  async createPracticeSession(request:savePracticeSessionRequest):Promise<number> {
    let endpoint = `${this.baseUrl}/practicesession`;
    let result = await firstValueFrom(this.http.put<savePracticeSessionResponse>(endpoint, request));
    return result.id;
  }

  async savePracticeSessionDrillResult(request:savePracticeSessionDrillResultsRequest):Promise<void> {
    let endpoint = `${this.baseUrl}/practicesessiondrillresult`;
    await firstValueFrom(this.http.put(endpoint, request));
    return;
  }

  async searchPracticeSessions(request:searchPracticeSessionsRequest):Promise<Array<practiceSessionSearchResponse>> {
    let endpoint = `${this.baseUrl}/practicesessions`;
    let results = await firstValueFrom(this.http.post<Array<practiceSessionSearchResponse>>(endpoint, request));
    return results;
  }

  async searchPracticeSessionDrillResults(request:searchPracticeSessionDrillResultsRequest):Promise<Array<practiceSessionDrillResultSearchResponse>> {
    let endpoint = `${this.baseUrl}/practicesessiondrillresults`;
    let results = await firstValueFrom(this.http.post<Array<practiceSessionDrillResultSearchResponse>>(endpoint, request));
    return results;
  }
}
